import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fip-no-data',
  templateUrl: './no-data.component.html',
  styleUrls: ['./no-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NoDataComponent {}
